import { NO_INVOICE_FILTER_ID } from 'containers/jobs/constant';

export enum InvoiceVersion {
  THREE_POINT_ZERO = '3.0'
}

export enum InvoiceSourceEnum {
  WEB = 'Web',
  MOBILE = 'Mobile'
}

export enum InvoiceTimelineCTAActions {
  SHARE_INVOICE = 'share-invoice'
}

export const INVOICE_STATUS_FILTER = [
  {
    label: 'No invoice',
    value: NO_INVOICE_FILTER_ID
  },
  {
    label: 'Paid',
    value: 'PAID-QR,PAID'
  },
  {
    label: 'Pending',
    value: 'PENDING,PROCESSING'
  }
];

import { ChargeCardErrorState, ChargeCardSuccessState } from './types';

export const initialChargeCardErrorState: ChargeCardErrorState = {
  isOpen: false,
  message: 'Payment Failed',
  subtitle: 'Something went wrong',
  txnId: '',
  cardLast4: '',
  network: '',
  canRetry: true
};

export const initialChargeCardSuccessState: ChargeCardSuccessState = {
  cardData: null,
  transactionId: '',
  isOpen: false
};

export const CARD_ON_FILE_MESSAGES = {
  NOT_ADMIN_ENABLED: 'Card on file is not enabled on your account yet. Please contact our support team to activate it.',
  TEAM_MEMBER: 'Card on file is not enabled for your team yet. Please contact your team owner/admin to enable it',
  TEAM_OWNER_ADMIN: 'Card on file is not enabled for your team yet. Please enable it from team settings'
};

export const MANUAL_KEY_IN_MESSAGES = {
  NOT_ADMIN_ENABLED:
    'Manual Card Entry is not enabled on your account yet. Please contact our support team to activate it.',
  TEAM_MEMBER: 'Manual Card Entry is not enabled for your team yet. Please contact your team owner/admin to enable it',
  TEAM_OWNER_ADMIN: 'Manual Card Entry is not enabled for your team yet. Please enable it from team settings'
};
